import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { Location } from '../components/Location';
import { Contact } from '../components/Contact';
export function Home() {
  return <main className="bg-black-rich min-h-screen w-full overflow-x-hidden font-sans" data-id="element-226">
      <Navigation data-id="element-227" />
      <Hero data-id="element-228" />
      <About data-id="element-229" />
      <Services data-id="element-230" />
      <Location data-id="element-231" />
      <Contact data-id="element-232" />

      {/* Footer */}
      <footer className="py-12 bg-black-DEFAULT border-t border-gray-900" data-id="element-233">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-235">
            <div className="flex items-center gap-2" data-id="element-236">
              <img src="https://cdn.magicpatterns.com/uploads/hVzgNEN2Eeix5JoWytq8hx/we.png" alt="Kings Gold Smelters Logo" className="h-10 w-auto opacity-80" data-id="element-237" />
              <span className="text-gray-400 font-bold text-sm" data-id="element-238">
                KINGS GOLD SMELTERS
              </span>
            </div>

            <p className="text-gray-600 text-sm text-center md:text-right" data-id="element-239">
              © {new Date().getFullYear()} Kings Gold Smelters Company Limited.
              <br data-id="element-240" />
              All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </main>;
}